import {
  FETCH_API_INFO_SUCCESS,
  FETCH_API_LOGS_SUCCESS
} from "api/apiInfo";

import packageJson from "../../../package.json";

const initialState = {
  backend: [],
  frontend: {
    version: packageJson.version
  },
  logs: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_API_INFO_SUCCESS:
      return {
        ...state,
        backend: action.payload
      };
    case FETCH_API_LOGS_SUCCESS:
      return {
        ...state,
        logs: action.payload
      };
    default:
      return state;
  }
}
